import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const AuditoryLeft = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <circle
          cx='6'
          cy='12'
          r='3.25'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M16.4742 2.27466C16.8405 1.90845 17.4342 1.90845 17.8004 2.27466C20.2883 4.76257 21.8288 8.20228 21.8288 12C21.8288 15.7977 20.2883 19.2374 17.8004 21.7253C17.4342 22.0916 16.8405 22.0916 16.4742 21.7253C16.108 21.3591 16.108 20.7654 16.4742 20.3992C18.6248 18.2486 19.9533 15.2803 19.9533 12C19.9533 8.71967 18.6248 5.7514 16.4742 3.60084C16.108 3.23463 16.108 2.64088 16.4742 2.27466Z'
          fill='currentColor'
        />
        <path
          d='M13.6008 6.47501C13.2346 6.1088 12.6409 6.1088 12.2747 6.47501C11.9084 6.84123 11.9084 7.43498 12.2747 7.80119C13.3505 8.87699 14.0142 10.3605 14.0142 12.0008C14.0142 13.6411 13.3505 15.1246 12.2747 16.2004C11.9084 16.5666 11.9084 17.1603 12.2747 17.5265C12.6409 17.8927 13.2346 17.8927 13.6008 17.5265C15.014 16.1134 15.8897 14.1585 15.8897 12.0008C15.8897 9.84309 15.014 7.88815 13.6008 6.47501Z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <circle cx='6' cy='12' r='4' fill='currentColor' />
        <path
          d='M16.4742 2.27466C16.8405 1.90845 17.4342 1.90845 17.8004 2.27466C20.2883 4.76257 21.8288 8.20228 21.8288 12C21.8288 15.7977 20.2883 19.2374 17.8004 21.7253C17.4342 22.0916 16.8405 22.0916 16.4742 21.7253C16.108 21.3591 16.108 20.7654 16.4742 20.3992C18.6248 18.2486 19.9533 15.2803 19.9533 12C19.9533 8.71967 18.6248 5.7514 16.4742 3.60084C16.108 3.23463 16.108 2.64088 16.4742 2.27466Z'
          fill='currentColor'
        />
        <path
          d='M13.6008 6.47501C13.2346 6.1088 12.6409 6.1088 12.2747 6.47501C11.9084 6.84123 11.9084 7.43498 12.2747 7.80119C13.3505 8.87699 14.0142 10.3605 14.0142 12.0008C14.0142 13.6411 13.3505 15.1246 12.2747 16.2004C11.9084 16.5666 11.9084 17.1603 12.2747 17.5265C12.6409 17.8927 13.2346 17.8927 13.6008 17.5265C15.014 16.1134 15.8897 14.1585 15.8897 12.0008C15.8897 9.84309 15.014 7.88815 13.6008 6.47501Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
